module.exports = __webpack_public_path__ + "static/media/court.2a334353.svg";